import ContactsDatabase from "../../pages/ContactsDatabase/CampaignDatabases";
import CamapaignsDetailDatabase from "../../pages/ContactsDatabase/DetailsDb";
import PartnerDatabases from "../../pages/Configuration/PartnerDatabases";
import ListaPreciosDefault from "../../pages/Configuration/ListaPreciosDefault";
import { createProtectedRoutes } from "../../utils/createdProtectedRoutes";
const routesConfig = [
  {
    path: "Db/ContactsDatabase",
    component: ContactsDatabase,
    roles: [1, 2, 3],
  },
  {
    path: "Db/DetailsDb/:id",
    component: CamapaignsDetailDatabase,
    roles: [1, 2, 3],
  },
  {
    path: "Contacts/ContactsDatabase",
    component: PartnerDatabases,
    roles: [1, 5],
  },
  {
    path: "Configuration/DefaultPrices",
    component: ListaPreciosDefault,
    roles: [1, 5],
  },
];

const contactsRoutes = createProtectedRoutes(routesConfig);
export default contactsRoutes;
